/* eslint-disable no-unsafe-optional-chaining */
import { faCircle, faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { map } from "lodash";
import React from "react";
import { Field, FormSpy, useForm } from "react-final-form";
import { Button, Table } from "reactstrap";

import { Product, ProductSizes, ProductStock, SizeStock, StockScope, StockStatus } from "../../resbutler-utils/types/product";

export const OverrideStockForm = ({ date, restaurantId, enabledProductSizes, productSizes, product, stockTypeKey }: { date: number; restaurantId: string; enabledProductSizes: string[]; productSizes: ProductSizes; product: Product; stockTypeKey: "products" | "specials" }) => {
  const form = useForm();

  /**If  totally new size data */
  const handleEnableChange = (productStockValues: ProductStock, sizeId: string, checked: boolean) => {
    const now = Date.now();
    const updatedProduct: ProductStock = productStockValues || {
      productId: product.id,
      restaurantId,
      date,
      createdAt: now,
      updatedAt: now,
      stockScope: StockScope.All,
      enabledMenus: {},
      sizes: {},
    };

    const newSize: SizeStock = {
      enabled: checked,
      isStockLimitEnabled: false,
      status: StockStatus.SoldOut,
    };

    form.change(`${stockTypeKey}.${product.id}`, {
      ...updatedProduct,
      sizes: {
        ...updatedProduct.sizes,
        [sizeId]: newSize,
      },
    });
  };

  const isSpecial = stockTypeKey === "specials";
  return (
    <FormSpy subscription={{ values: true }}>
      {({ values }) => {
        const productStockValues: ProductStock = values?.[stockTypeKey]?.[product.id];
        return (
          <>
            <Table size="sm">
              <thead>
                <tr>
                  <th>Size</th>
                  <th>Stock Limit</th>
                  <th>Stock Availability</th>
                </tr>
              </thead>
              <tbody>
                {map(enabledProductSizes, (sizeId) => {
                  const size = productSizes[sizeId];
                  const sizeData = productStockValues?.sizes?.[sizeId];
                  if (!sizeData && isSpecial) return null;
                  const disabled = !sizeData?.enabled;

                  return (
                    <React.Fragment key={`stock-size-${product.id}-${sizeId}`}>
                      <tr style={{ "--bs-table-accent-bg": "transparent" } as React.CSSProperties}>
                        <td className={`fw-bold`}>
                          <div className="d-flex ">
                            <Field name={`${stockTypeKey}.${product.id}.sizes.${sizeId}.enabled`}>
                              {({ input }) => (
                                <div className="checkbox c-checkbox">
                                  <label className="mb-1">
                                    <input
                                      {...input}
                                      type="checkbox"
                                      checked={input.value}
                                      onChange={(e) => {
                                        const checked = e.target.checked;
                                        if (!sizeData) handleEnableChange(productStockValues, sizeId, e.target.checked);
                                        else input.onChange(checked);
                                      }}
                                    />
                                  </label>
                                </div>
                              )}
                            </Field>
                            {size.name}
                          </div>
                        </td>

                        <td className={disabled ? `disabled-div` : ""}>
                          <StockLimitStepper stockTypeKey={stockTypeKey} productId={product.id} sizeId={sizeId} sizeEnabled={!!sizeData?.enabled} />
                        </td>

                        <td className={disabled ? `disabled-div` : ""}>
                          <div className="d-flex  pt-2">
                            {[StockStatus.SoldOut, StockStatus.Hide].map((status) => (
                              <Field key={status} name={`${stockTypeKey}.${product.id}.sizes.${sizeId}.status`} type="radio" value={status}>
                                {({ input }) => (
                                  <div className="radio c-radio">
                                    <label>
                                      <input {...input} checked={sizeData?.enabled ? input.checked : false} />
                                      <FontAwesomeIcon icon={faCircle} className="radio-indicator" />
                                      {status}
                                    </label>
                                  </div>
                                )}
                              </Field>
                            ))}
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
            </Table>
          </>
        );
      }}
    </FormSpy>
  );
};

type StockLimitStepperProps = {
  productId: string;
  sizeId: string;
  stockTypeKey: string;
  sizeEnabled: boolean;
};

const StockLimitStepper: React.FC<StockLimitStepperProps> = ({ productId, sizeId, stockTypeKey, sizeEnabled }) => {
  return (
    <FormSpy subscription={{ values: true }}>
      {({ values }) => {
        const item = values?.[stockTypeKey]?.[productId]?.sizes?.[sizeId];
        const isEnabled = sizeEnabled && (item?.isStockLimitEnabled || false);

        return (
          <div className="d-flex ">
            <div className="checkbox c-checkbox py-2">
              <label>
                <Field name={`${stockTypeKey}.${productId}.sizes.${sizeId}.isStockLimitEnabled`} type="checkbox">
                  {({ input }) => <input {...input} checked={sizeEnabled ? input.checked : false} />}
                </Field>
              </label>
            </div>

            <div className={`d-flex mt-1 ${!isEnabled ? "disabled-div" : ""}`}>
              <Field name={`${stockTypeKey}.${productId}.sizes.${sizeId}.limit`}>
                {({ input }) => (
                  <>
                    <Button className="border px-2 h-75" size="sm" disabled={!isEnabled} onClick={() => input.onChange(Math.max(0, (input.value || 0) - 1))}>
                      <FontAwesomeIcon icon={faMinus} />
                    </Button>

                    <span className="my-1 mx-2">{sizeEnabled ? input.value || 0 : 0}</span>

                    <Button className="border px-2 h-75" size="sm" disabled={!isEnabled} onClick={() => input.onChange((input.value || 0) + 1)}>
                      <FontAwesomeIcon icon={faPlus} />
                    </Button>
                  </>
                )}
              </Field>
            </div>
          </div>
        );
      }}
    </FormSpy>
  );
};
